<template>
    <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M2.54651 6.90698C2.54651 4.83727 3.98309 3.1077 5.91502 2.65949L5.72573 2.97497C5.57705 3.22278 5.6574 3.54419 5.90521 3.69287C6.15301 3.84156 6.47442 3.7612 6.62311 3.5134L7.35566 2.29247C7.45265 2.13082 7.45519 1.92949 7.36231 1.76545C7.26943 1.6014 7.09549 1.5 6.90698 1.5C3.91799 1.5 1.5 3.91799 1.5 6.90698C1.5 7.19596 1.73427 7.43023 2.02326 7.43023C2.31224 7.43023 2.54651 7.19596 2.54651 6.90698Z"
            fill="#FF9E48"
        />
        <path
            d="M16.5 11.093C16.5 10.804 16.2657 10.5698 15.9767 10.5698C15.6878 10.5698 15.4535 10.804 15.4535 11.093C15.4535 13.1627 14.0169 14.8923 12.085 15.3405L12.2743 15.025C12.423 14.7772 12.3426 14.4558 12.0948 14.3071C11.847 14.1584 11.5256 14.2388 11.3769 14.4866L10.6443 15.7075C10.5473 15.8692 10.5448 16.0705 10.6377 16.2346C10.7306 16.3986 10.9045 16.5 11.093 16.5C14.082 16.5 16.5 14.082 16.5 11.093Z"
            fill="#FF9E48"
        />
        <path
            d="M15.9767 3.55814V3.63488C15.9767 3.83023 15.8233 3.98372 15.6279 3.98372H9.34884C9.15349 3.98372 9 3.83023 9 3.63488V3.55814C9 2.33023 9.30698 2.02326 10.5488 2.02326H14.4279C15.6698 2.02326 15.9767 2.33023 15.9767 3.55814Z"
            fill="#FF9E48"
        />
        <path
            d="M9 5.02925C9 4.8339 9.15349 4.68041 9.34884 4.68041H15.6279C15.8233 4.68041 15.9767 4.8339 15.9767 5.02925V6.41762C15.9767 7.64553 15.6698 7.95251 14.4279 7.95251H10.5488C9.30698 7.95251 9 7.64553 9 6.41762V5.02925Z"
            fill="#FF9E48"
        />
        <path
            d="M9 11.5814V11.6581C9 11.8535 8.84651 12.007 8.65116 12.007H2.37209C2.17674 12.007 2.02326 11.8535 2.02326 11.6581V11.5814C2.02326 10.3535 2.33023 10.0465 3.57209 10.0465H7.45116C8.69302 10.0465 9 10.3535 9 11.5814Z"
            fill="#FF9E48"
        />
        <path
            d="M2.02326 13.0525C2.02326 12.8572 2.17674 12.7037 2.37209 12.7037H8.65116C8.84651 12.7037 9 12.8572 9 13.0525V14.4409C9 15.6688 8.69302 15.9758 7.45116 15.9758H3.57209C2.33023 15.9758 2.02326 15.6688 2.02326 14.4409V13.0525Z"
            fill="#FF9E48"
        />
    </svg>
</template>

<script>
export default {
    data() {
        return {};
    },
};
</script>
